import React from 'react';
import styled from 'styled-components';

import ColorPalette from '../colors/ColorPalette';
import MaskColorPalette from '../colors/MaskColorPalette';
import TransparentColorPalette from '../colors/TransparentColorPalette';
import IndexVars from '../VariableIndex';
import VariableFeatures from '../VariableFeatures.js';
import VariableTextSize from '../VariableTextSize.js';

import SizeVars from '../VariableSize';
import PositionVars from '../VariablePositions';
import {ColorThemeContainer} from './ColorThemeContainer';

export const ColorTheme = ({children}) => <ColorThemeContainer>{children}</ColorThemeContainer>;

export const ColorThemeWrapper = styled(ColorThemeContainer)`
    ${ColorPalette}
    ${MaskColorPalette}
    ${TransparentColorPalette}
    ${IndexVars}
    ${VariableFeatures}
    ${SizeVars}
    ${PositionVars}
    ${VariableTextSize}
`;

ColorTheme.Wrapper = ColorThemeWrapper;
